import { render, staticRenderFns } from "./FaceBiometry.vue?vue&type=template&id=27f418ea"
import script from "./FaceBiometry.vue?vue&type=script&lang=js"
export * from "./FaceBiometry.vue?vue&type=script&lang=js"
import style0 from "./FaceBiometry.vue?vue&type=style&index=0&id=27f418ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports